/**
 * Checkbox — label sits beside the control (not above, unlike TextField/
 * Select), so it doesn't route through FormField. Used for consent/
 * acknowledgement rows (VIB received, risk warnings, §2a declaration) as
 * much as plain booleans — `label` should be the full sentence the user is
 * agreeing to, not a short field name.
 */
export function Checkbox({ id, label, checked = false, error, required = false, onChange }) {
  const wrap = document.createElement("div");
  wrap.className = "form-field form-field-checkbox";

  const row = document.createElement("label");
  row.className = "form-checkbox-row";
  row.htmlFor = id;

  const input = document.createElement("input");
  input.type = "checkbox";
  input.id = id;
  input.name = id;
  input.checked = checked;
  input.required = required;
  input.setAttribute("aria-invalid", error ? "true" : "false");
  if (error) input.setAttribute("aria-describedby", `${id}-error`);
  if (onChange) input.addEventListener("change", () => onChange(input.checked));

  const text = document.createElement("span");
  text.textContent = label;

  row.append(input, text);
  wrap.append(row);

  if (error) {
    const errorEl = document.createElement("p");
    errorEl.id = `${id}-error`;
    errorEl.className = "form-error";
    errorEl.textContent = error;
    wrap.append(errorEl);
  }

  return wrap;
}
